<template>
  <div class="wrapper" v-if="isReady">
    <webHeader :is-fixed-header="isFixedGameTab"></webHeader>
    <div id="mobileHeader" ref="mobileHeader">
      <mobileHeader></mobileHeader>
    </div>
    <Banner></Banner>
    <div class="content">
      <div id="marqueeBlock" class="marquee-block" ref="marqueeBlock">
        <MarqueeComponent></MarqueeComponent>
      </div>
      <GameTabComponent
        :is-fixed-game-tab.sync="isFixedGameTab"
        :current-game-tab="currentGameTab"
        :set-tab="setTab"
        :tab-game-list="tabGameList"
        :is-device="isDevice"
        :loading="gameLoading"
      />
      <GameListComponent
        :is-fixed-game-tab.sync="isFixedGameTab"
        :result-game-list="resultGameList"
        :refresh-status="refresh"
        :loading="gameLoading"
        @windowPage="getWindowPage"
      />
    </div>
    <ModalComponent></ModalComponent>
    <Footer></Footer>
    <notifications position="top center" :duration="3000" classes="custom-template"></notifications>
    <goTop></goTop>
    <LoadingAnimate :is-loading="isLoading"/>
    <BetDetailIframe/>

    <!--    <button @click="openModal">example modal</button>-->
  </div>
</template>

<script>
import Footer from '@/components/layout/footer'
import mobileHeader from '@/components/layout/mobileHeader'
import webHeader from '@/components/layout/webHeader'
import goTop from '@/components/layout/goTop'
import Banner from '@/components/layout/banner'
import MarqueeComponent from '@/components/layout/marquee'
import ModalComponent from '@/components/modals/modal'
import GameTabComponent from '@/components/layout/game/gameTab'
import GameListComponent from '@/components/layout/game/gameList'
import LoadingAnimate from '@/components/layout/loadingAnimate'
import BetDetailIframe from '@/components/layout/betDetailIframe'
import Base from '@/mixins/base'
import { mapState } from 'vuex'
import { getGameList, getGuestGameList } from '@/service/api/game'
import { checkToken } from '@/service/api/token'
import { checkIsLogin } from '@/service/api/isLoggedin'
import { getBalance } from '@/service/api/wallet'
import { mapList, mapHiddenList, mapDSList, mapOperList } from '@/setting'
import { isTgGame , isMobile } from '@/plugins/isTypes'

export default {
  name: 'GameLobby',
  data() {
    return {
      urlQuery: [],
      currentGameTab: 'hot',
      isFixedGameTab: false,
      isDevice: 'desktop',
      originGameList: [],
      resultGameList: [],
      tabGameList: {
        hot: [],
        fish: [],
        slot: [],
        arcade: [],
      },
      isReady: false,
      windowPage: null,
      timer: null,
      mapGameTypes: {
        fish: { 'num': 1, 'name': 'fish' },
        chess: { 'num': 2, 'name': 'chess' },
        slot: { 'num': 3, 'name': 'slot' },
        arcade: { 'num': 4, 'name': 'arcade' },
      },
      gameLoading: '-', // 遊戲清單載入狀態
    }
  },
  mixins: [
    Base
  ],
  computed: {
    ...mapState({
      isLoading: state => state.loading.isLoading,
      identity: state => state.user.identity,
    }),
  },
  watch: {},
  components: {
    Footer,
    mobileHeader,
    webHeader,
    goTop,
    Banner,
    MarqueeComponent,
    ModalComponent,
    GameTabComponent,
    GameListComponent,
    LoadingAnimate,
    BetDetailIframe
  },
  created() {
    this.setDocumentTitle()
    this.detectionDevice()
    this.refreshEffect()
  },
  async mounted() {
    window.addEventListener('scroll', this.fixedGameTab)
    window.addEventListener('resize', this.detectionDevice)
    await this.init()
    this.isReady = true
    if ((isMobile() || isTgGame()) && window.history && window.history.pushState) {
      // 監聽瀏覽器返回上一頁事件
      window.addEventListener('popstate', this.getAccBalance)
    } else {
      this.timer = setInterval(() => {
        if (this.windowPage !== null && this.windowPage.closed) {
          this.getAccBalance()
          // clearInterval(this.timer) // 單純刷新餘額 不會整頁重新整理 所以必須要一直持續監聽
          // console.log('closed')
        }
        // console.log('end')
      }, 5000)
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.fixedGameTab)
    window.removeEventListener('resize', this.detectionDevice)
    window.removeEventListener('popstate', this.getAccBalance)
    clearInterval(this.timer) // 單純刷新餘額 不會整頁重新整理 所以必須要一直持續監聽
  },
  methods: {
    /**
     * 初始oper
     * @returns {Promise<void>}
     */
    async initOper() {
      console.log('initOper')
      const urlParams = new URLSearchParams(location.search)
      // init token
      let oper = urlParams.get('oper') ?? false
      console.log('initOper url', oper)
      // 有auth 優先使用auth
      if (urlParams.has('auth')) {
        const auth = this.decodeAuth(urlParams.get('auth'))
        const { a } = auth
        oper = a?.o
        console.log('initOper auth', oper, auth)
      }

      switch (true) {
        case (!oper || oper === ''):
          this.resetOper()
          break
        default:
          localStorage.setItem('oper', oper)
      }
    },
    /**
     * 初始TgGame
     * @returns {Promise<void>}
     */
    async initTgGame() {
      console.log('initTgGame')
      const urlParams = new URLSearchParams(location.search)
      // init token
      let tggame = urlParams.get('tggame') ?? false
      console.log('init tggame', tggame)
      switch (true) {
        case (!tggame || tggame === ''):
          localStorage.removeItem('tggame')
          break
        default:
          localStorage.setItem('tggame', tggame)
      }
    },
    /**
     * 初始mode demoLink || newgame
     * @returns {Promise<void>}
     */
    async initMode() {
      console.log('initMode')
      const urlParams = new URLSearchParams(location.search)
      // init token
      let mode = urlParams.get('mode') ?? false
      console.log('init mode', mode)
      switch (true) {
        case (mode === 'newgame'):
          localStorage.setItem('mode', mode)
          break;
        case (mode === 'demoLink'):
          localStorage.setItem('mode', mode)
          break
        default:
          localStorage.removeItem('mode')
      }
    },
    /**
     * 初始遊戲分類頁籤 fish || slot || arcade
     */
    initGtype() {
      const urlParams = new URLSearchParams(location.search)
      const gtype = urlParams.get('gtype') ?? false
      const allowed = ['fish', 'slot', 'arcade']
      if (allowed.includes(gtype)) {
        this.currentGameTab = gtype
      }
    },
    /**
     * 初始token
     * @returns {Promise<void>}
     */
    async initToken() {
      const urlParams = new URLSearchParams(location.search)
      // init token
      let token = urlParams.get('token') ?? false
      console.log('initToken url', token)
      // 有auth 優先使用auth
      if (urlParams.has('auth')) {
        const auth = this.decodeAuth(urlParams.get('auth'))
        const { t } = auth
        token = (t === 'guest') ? t : urlParams.get('auth')
        console.log('initToken auth', token, auth)
      }
      // 沒有url params 但有登入過 , 或從遊戲返回大廳
      if (!token && localStorage.getItem('isLoggedin') === 'true' && localStorage.getItem('token')) {
        token = localStorage.getItem('token')
        console.log(token)
      }

      switch (true) {
        case (!token || token === ''):
          localStorage.removeItem('token')
          this.$message({
            message: 'Login Failed',
            type: 'error'
          })
          break
        case (token === 'guest'):// 訪客模式
          localStorage.setItem('token', token)
          localStorage.setItem('isGuest', 'true')
          this.$store.dispatch('user/setLoginIdentity', 'guest') // 設定登入身份為訪客
          this.$store.dispatch('user/setLoginAccount', 'guest') // 設定登入帳號為guest
          this.getAccBalance() // 取餘額
          this.getGames(this.identity) // 取遊戲清單
          break
        default:
          console.log(token)
          const res = await this.checkTokenOrIsLogin(token)
          if (!res) return
          localStorage.setItem('token', token)
          this.initExtra()
          this.getAccBalance() // 取餘額
          this.getGames(this.identity) // 取遊戲清單
      }
    },
    initExtra() {
      const token = localStorage.getItem('token') // 修正：get -> getItem
      if (!token) return
      
      const auth = this.decodeAuth(token)
      const { a } = auth
      if (a?.e) {
        localStorage.setItem('extra', a.e)
      } else {
        localStorage.removeItem('extra')
      }
    },
    async init() {
      const urlParams = new URLSearchParams(location.search)
      console.log('>>>>', urlParams.has('auth'))
      this.initOper()
      this.initMode()
      this.initTgGame()
      this.initGtype()
      this.initToken()
    },
    /**
     * 初始化
     */
    // async init2() {
    //   // 先檢查token 如果有取到就取資料
    //   console.log(location.search)
    //   const urlParams = new URLSearchParams(location.search)
    //   console.log('網址是否帶token？', urlParams.has('token'), '網址帶的token', urlParams)
    //   // 如果url沒有oper清除
    //   if (urlParams.has('oper')) {
    //     localStorage.setItem('oper', urlParams.get('oper'))
    //   } else {
    //     this.resetOper()
    //   }
    //   console.log('get oper？', localStorage.getItem('oper'))
    //   if (urlParams.has('token') === true && urlParams.get('token') !== '') {
    //     localStorage.setItem('token', urlParams.get('token'))
    //     if (urlParams.get('token') === 'guest') {
    //       // 訪客模式
    //       localStorage.setItem('isGuest', 'true')
    //       this.$store.dispatch('user/setLoginIdentity', 'guest') // 設定登入身份為訪客
    //       this.$store.dispatch('user/setLoginAccount', 'guest') // 設定登入帳號為guest
    //     } else {
    //       await this.checkTokenOrIsLogin(urlParams.get('token'))
    //     }
    //     this.getAccBalance() // 取餘額
    //     this.getGames(this.identity) // 取遊戲清單
    //   } else if (localStorage.getItem('isLoggedin') === 'true' && localStorage.getItem('token')) {
    //     console.log(localStorage.getItem('isLoggedin'), localStorage.getItem('token'))
    //     await this.checkTokenOrIsLogin(localStorage.getItem('token'))
    //     this.getAccBalance() // 取餘額
    //     this.getGames(this.identity) // 取遊戲清單
    //   } else {
    //     console.log('Not get token.')
    //     this.$message({
    //       message: 'Login Failed',
    //       type: 'error'
    //     })
    //   }
    // },
    /**
     * 清除白牌
     */
    resetOper() {
      const oper = localStorage.getItem('oper')
      const mapStr = [...new Set([...mapList, ...mapHiddenList, ...mapDSList, ...Object.keys(mapOperList)])]
      if (!mapStr.includes(oper)) {
        localStorage.removeItem('oper')
      }
    },
    /**
     * 檢查token或是否登入
     */
    async checkTokenOrIsLogin(token) {
      const checkTokenRes = await checkToken(token)
      console.log(checkTokenRes, token)
      if (checkTokenRes.code === 200 && checkTokenRes.result.result.code === 1) {
        this.$store.dispatch('user/setLoginIdentity', 'member') // 設定登入身份為會員
        this.$store.dispatch('user/setLoginAccount', checkTokenRes.result.member.account) // 取帳號
        localStorage.setItem('isLoggedin', 'true')
        localStorage.setItem('member', JSON.stringify(checkTokenRes.result.member))
        return true
        // localStorage.setItem('oper', checkTokenRes.result.member.oper?.value )
      } else {

        if (!this.vertifyRefresh()) {
          this.logout()
          return false
        }
        const checkIsLoginRes = await checkIsLogin()
        if (checkIsLoginRes.code === 200 && checkIsLoginRes.result.result.code === 1) {
          const info = JSON.parse(localStorage.getItem('member'))
          this.$store.dispatch('user/setLoginIdentity', 'member') // 設定登入身份為會員
          this.$store.dispatch('user/setLoginAccount', info.account) // 取帳號
          return true
        } else {
          // 清除登入相關資訊
          this.logout(`${checkIsLoginRes.result.result.msg} (${checkIsLoginRes.result.result.code})`)
        }
      }
      console.log('checkTokenOrIsLogin end')
      return false
    },
    /**
     * 重新整理時候 auth && token 失效
     * 檢查是否相同
     */
    vertifyRefresh() {
      const urlParams = new URLSearchParams(location.search)
      if(!urlParams.has('auth')) return true
      // init token
      const token = urlParams.get('token') ?? false
      const auth = urlParams.get('auth') ?? false
      const storage = localStorage.getItem('token') ?? false

      console.log(auth !== storage , token !== storage)
      if (auth !== storage && token !== storage) return false
      return true

    },
    /**
     * 取餘額
     */
    async getAccBalance() {
      if (this.identity === 'guest') {
        this.$store.dispatch('user/setAccountBalance', '10000000000') // 設定帳號餘額為100000000
        return
      }
      const res = await getBalance()
      if (res.code === 200) {
        this.$store.dispatch('user/setAccountBalance', res.result.balance) // 取餘額
      } else {
        this.$message({
          message: `${res.result.result.msg}` + ` (${res.result.result.code})`,
          type: 'error'
        })
      }
      console.log('getAccBalance end', res)
    },
    /**
     * 設定當前tab
     */
    setTab(type) {
      this.currentGameTab = type
      this.sortGameType(type)
      this.refreshEffect()
    },
    /**
     * 固定gameTab
     */
    fixedGameTab() {
      // 電腦版抓跑馬燈 手機版抓mobileHeader
      const element_ = this.isDevice === 'mobile' ? this.$refs.mobileHeader.offsetTop - 60 : this.$refs.marqueeBlock.offsetTop - 60
      // console.log('element_', element_)
      // console.log('window.pageYOffset', window.pageYOffset)
      this.isFixedGameTab = window.pageYOffset >= element_
    },
    /**
     * 取遊戲清單
     */
    async getGames(val) {
      console.log('getGames', val)
      if (!['guest', 'member'].includes(val)) return
      this.gameLoading = true // 遊戲清單載入開始
      let res = val === 'guest' ? await getGuestGameList() : val === 'member' ? await getGameList() : ''
      const origin_ = []
      if (res && res.code === 200 && res.result.result.code === 1) {
        // 先排除關閉的
        res.result.rowsList.forEach((item) => {
          if (!item.disabled) origin_.push(item)
        })
        // console.log('origin_', origin_)
        this.originGameList = origin_.map((item) => {
          let gameNameList = []
          item.namesMap.forEach((item) => {
            gameNameList.push(item[1])
          })
          // console.log('gameNameList', gameNameList)
          return { ...item, gameNameList }
        })
      } else {
        this.$message({
          message: `${res.result.result.msg}` + ` (${res.result.result.code})`,
          type: 'error'
        })
      }
      this.gameLoading = false // 遊戲清單載入結束
      // console.log('原始遊戲清單：', this.originGameList)
      // 設定遊戲分類清單
      Object.keys(this.tabGameList).forEach(item => {
        const typeNum = Number(this.mapGameTypes[item]?.num)
        if (item === 'hot') this.tabGameList.hot = this.originGameList.filter(item => item.hot === true)
        else this.tabGameList[item] = this.originGameList.filter(item => item.gameType === typeNum)

        // [測試]分類遊戲為空(一樣分類的 resultGameList 也要清空)
        // if (item === 'hot') this.tabGameList.hot = []
        // if (item === 'slot') this.tabGameList.slot = []
        // if (item === 'fish') this.tabGameList.fish = []
        // if (item === 'arcade') this.tabGameList.arcade = []
      })
      console.log('各分類遊戲清單：', this.tabGameList)
      const selectedList = this.tabGameList[this.currentGameTab]
      if (this.currentGameTab !== 'hot' && (!selectedList || selectedList.length === 0)) {
        this.currentGameTab = 'hot'
      }
      this.sortGameType(this.currentGameTab)
    },
    /**
     * 遊戲分類篩選
     */
    sortGameType(type) {
      console.log('遊戲分類：', type)
      this.resultGameList = (type === 'hot') ? this.originGameList.filter(item => item.hot === true) : this.originGameList.filter(item => item.gameType === this.mapGameTypes[type].num)

      // [測試]分類遊戲為空(一樣分類的 tabGameList 也要清空)
      // if (type === 'hot') this.resultGameList = []
      // if (type === 'slot') this.resultGameList = []
      // if (type === 'fish') this.resultGameList = []
      // if (type === 'arcade') this.resultGameList = []

      console.log('分類後遊戲清單', this.resultGameList)
    },
    /**
     * 取得開啟新視窗回傳值
     */
    getWindowPage(item) {
      this.windowPage = item
    },
    /**
     * 判斷目前的螢幕寬度 以1023為基準
     */
    detectionDevice() {
      let intViewportWidth = window.innerWidth
      this.isDevice = (intViewportWidth > 1023) ? 'desktop' : 'mobile'
    },
    /**
     * 刷新遊戲大廳
     */
    refreshLobby() {
      window.location.reload()
    },
    /**
     * 開啟 modal 彈窗
     */
    openModal() {
      this.$store.dispatch('modal/toggleModal', {
        name: 'commonBox',
        message: '測試',
        status: true
      })
    },
  }
}
</script>
<style lang="scss" src="@/assets/css/app.scss"></style>
